<template>
  <esg-base-chart class="no-hover">
    <loading :active="loading"
             :z-index="1000"
             :is-full-page="false"/>
    <apex-chart type="donut"
                ref="chart"
                height="250"
                v-show="!loading"
                :options="chartOptions"
                :series="series"/>
  </esg-base-chart>
</template>
<script>
import EsgBaseChart from "@/components/esg/base/EsgBaseChart.vue";

export default {
  name: 'CT00008',
  components: { EsgBaseChart },
  props: {
    color: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      loading: false,
      series: [],
      chartOptions: {
        colors: ['#999', '#999', this.color],
        chart: {
          type: 'donut',
          fontFamily: 'NanumGothic, serif',
        },
        tooltip: {
          enabled: false,
        },
        legend: {
          show: false,
        },
        dataLabels: {
          enabled: false,
        },
        states: {
          hover: {
            filter: {
              type: 'none',
            }
          },
          active: {
            allowMultipleDataPointsSelection: false,
            filter: {
              type: 'none',
            }
          },
        },
        plotOptions: {
          pie: {
            expandOnClick: false,
            donut: {
              labels: {
                show: true,
                value: {
                  show: true,
                  fontSize: '16px'
                },
                total: {
                  show: true,
                  showAlways: true,
                  color: 'black',
                  label: 'Scope 3',
                  fontWeight: 600,
                  formatter: chart => {
                    const scope3Emission = chart.config.series.at(-1)
                    const total = chart.config.series.reduce((a, b) => a + b, 0)
                    const share = this.formatNumber(100 * scope3Emission / total, 2);
                    return [`${this.formatNumber(scope3Emission, 0)} tCO2e`, `${share}%`]
                  }
                },
              },
            },
          },
        },
      },
    }
  },
  created() {
    this.fetchData();
  },
  beforeDestroy() {
    if (this.abortController) {
      this.abortController.abort();
    }
  },
  methods: {
    async fetchData() {
      try {
        this.loading = true;

        let year = new Date().getFullYear();
        let args = [{
          years: [year],
          scopes: [1, 2, 3],
          groupKeys: ['year', 'scope']
        }];

        let data = new FormData()
        data.append('path', 'esg/ghg_emission/main');
        data.append('json', JSON.stringify(args));

        this.abortController = new AbortController();
        let response = await axios.post('esg/lca/run/python/chart-data', data, {
          headers: { Authorization: accessToken() },
          signal: this.abortController.signal
        });

        if (!response.data.data) {
          this.series = [];
          return;
        }

        let list = JSON.parse(response.data.data)[0].data

        this.series = list.map(row => row.values);
        this.chartOptions.labels = list.map(row => `Scope ${row.scope}`);
      } catch (error) {
        this.loading = false;
        await this.showError(error);
      } finally {
        this.loading = false;
        this.refreshChart();
      }
    },
  }
}
</script>

<style scoped>
.no-hover {
  pointer-events: none;
}

>>> .apexcharts-datalabels-group {
  transform: translateY(-5%);
  white-space: break-spaces;
}
</style>
